/**
 * Parse a combined primary lookup value (email, phone, or passport ID).
 */
export function parsePatientPrimaryLookupQuery(query = "") {
	const trimmed = String(query || "").trim();
	if (!trimmed) {
		return {};
	}
	if (trimmed.includes("@")) {
		return { email: trimmed.toLowerCase() };
	}
	if (trimmed.startsWith("+")) {
		return { mobile: trimmed };
	}
	return { passport_id: trimmed };
}
